import { gql } from "@apollo/client";

const schema = {
  report: {
    name: "usersWithAnalisys",
    serviceName: "unitadmin",
    query: gql`
      query usersWithAnalisys(
        $ids: [String]
        $national_codes: [String]
        $emails: [String]
        $tellphones: [String]
        $cellphones: [String]
        $status_ids: [String]
        $unit_ids: [String]
        $username: String
        $firstname: String
        $lastname: String
        $gender: Int
        $is_active: Int
        $birth_date: String
        $skin_color: String
        $has_role_name: String
        $has_permission_name: String
        $lab_ids: [String]
        $device_zones: [String]
        $user_category_ids: [String]
        $user_section: String
        $medical_numbers: String
        $specialists: String
        $insurance_type: String
        $financial_situation: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        usersWithAnalisys(
          ids: $ids
          national_codes: $national_codes
          emails: $emails
          tellphones: $tellphones
          cellphones: $cellphones
          status_ids: $status_ids
          unit_ids: $unit_ids
          username: $username
          firstname: $firstname
          lastname: $lastname
          gender: $gender
          is_active: $is_active
          birth_date: $birth_date
          skin_color: $skin_color
          has_role_name: $has_role_name
          has_permission_name: $has_permission_name
          lab_ids: $lab_ids
          device_zones: $device_zones
          user_category_ids: $user_category_ids
          user_section: $user_section
          medical_numbers: $medical_numbers
          specialists: $specialists
          insurance_type: $insurance_type
          financial_situation: $financial_situation
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          count
        }
      }
    `,
  },
};

export default schema;
